{
    "ConsidermovedtounresolvedasoverflowedLabel": "Consider Calls Moved To Unresolved Devices As Overflowed:",
    "NAME": "StatisticCalculations",
    "StatisticCalculations_SectionHeader": "Statistic Calculations",
    "StatisticCalculations_SectionPara": "You can choose whether calls are considered as overflowed or abandoned when the application deliberately terminates their modelling for calls moved to unmonitored or unknown device locations."
}